import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COLORS } from '@btime/constants'
import { useLinkTreeFormActions } from './_form/LinkTreeFormHandler'
import { useRemoveLinkTreeItem } from './_request/removeLinkTreeItem'
import Center from '../../../packages/kiti/components/helpers/Center'
import FlexGrid from '../../../components/structure/FlexGrid'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Link from '../../../packages/kiti/components/actions/Link'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import Tooltip from '../../../components/helpers/Tooltip'
import LinkTreeItemHistoryFilterModal from './sections/LinkTreeItemHistoryFilterModal'

const Action = ({ label, onClick, predicate = true, icon, iconColor, loading }) => {
  return (
    <>
      <Link block onClick={onClick}>
        <Tooltip
          actionContent={
            <Center>
              <Icon
                name={icon}
                color={predicate ? (iconColor ? iconColor : COLORS.dark3) : COLORS.light3}
                size=".8rem"
              />
            </Center>
          }
          top="1.2rem"
        >
          {label}
        </Tooltip>
      </Link>
      {loading && <Loading />}
    </>
  )
}

const LinkTreeActions = ({ index, item, isLast }) => {
  const { t } = useTranslation('editLinkTreeItems')
  const [removeOnApi, { loading }] = useRemoveLinkTreeItem()
  const { duplicateLinkTreeItem, onMoveUp, onMoveDown, removeLinkTreeItem } = useLinkTreeFormActions()
  const [openLinkModal, setOpenLinkModal] = useState(false)
  const canMoveUp = index > 0
  const canMoveDown = !isLast
  const isPublicHistory = item?.configuration?.isPublicHistory

  const handleRemove = () => {
    if (item.id) removeOnApi(item.id)
    removeLinkTreeItem(index)
  }

  return (
    <FlexGrid justify="flex-end" gutter={0.5}>
      <Action
        label={t('configHistory')}
        icon="BsFilter"
        onClick={() => !!isPublicHistory && setOpenLinkModal(true)}
        predicate={!!isPublicHistory}
      />
      <Action label={t('moveUp')} icon="BsArrowUp" onClick={() => canMoveUp && onMoveUp(index)} predicate={canMoveUp} />
      <Action
        label={t('moveDown')}
        icon="BsArrowDown"
        onClick={() => canMoveDown && onMoveDown(index)}
        predicate={canMoveDown}
      />
      <Action label={t('duplicate')} icon="BsLayers" onClick={() => duplicateLinkTreeItem(index)} />
      <Action label={t('remove')} icon="BsTrash" iconColor={COLORS.red} onClick={handleRemove} loading={loading} />

      {isPublicHistory && openLinkModal === true && (
        <LinkTreeItemHistoryFilterModal
          index={index}
          item={item}
          open={openLinkModal}
          onClose={() => setOpenLinkModal(false)}
        />
      )}
    </FlexGrid>
  )
}

export default LinkTreeActions
